<template>
  <brand-module-detail :is-edit='true'>
  </brand-module-detail>
</template>

<script>
import BrandModuleDetail from '../components/BrandModuleDetail'
export default {
  name: 'EditNavigate',
  components: {
    BrandModuleDetail
  }
}
</script>
